<template>
  <div>
    <title>交易记录</title>
    <section class="mainPart">
      <!--S 公用头部切换-->
      <CompanyTabJsz :active="currentTit" :flowcode="flowcode"></CompanyTabJsz>
      <!--E 公用头部切换-->
      <el-tabs v-model="activeName" class="quotaTab">
        <el-tab-pane label="销售下单" name="first">
          <!--S 销售单列表-->
          <SaleOrderList v-if="show" :tabIndex="activeName" :fsxzfje="sellType" :orderucode="sellType==0?flowcode:''" :corderucode="sellType==1?flowcode:''" :saleOrderType="0" class="pt0"></SaleOrderList>
          <!--E 销售单列表-->
        </el-tab-pane>
        <el-tab-pane label="退款申请" name="second">
          <RefundInfo v-if="show" :tabIndex="activeName" :refundType="sellType==0?1:0" :applyercode="sellType==1?flowcode:''" class="pt0"></RefundInfo>
        </el-tab-pane>
      </el-tabs>
    </section>
  </div>
</template>
<script>
export default {
  name:'TransactionRecord',
  data(){
    return{
      show:true,
      flowcode:'0',
      sellType:'',
      currentTit:3,//选中的tab
      activeName:'first',
    }
  },
  //================================================ 组件 ================================================
  components: {
    CompanyTabJsz: resolve => require(["@/components/ManageFolder/CompanyTabJsz.vue"],resolve), //头部tab组件
    SaleOrderList: resolve => require(["@/components/OrderFolder/StoreSale/SaleOrderList.vue"], resolve),//销售单列表组件
    RefundInfo: resolve => require(["@/components/OrderFolder/StoreSale/RefundInfo.vue"], resolve),//退款申请组件
  },
  //================================================ 监听 ================================================
  watch:{
  },
  //================================================ 方法 ================================================
  methods: {
    
  },
  //================================================ 生命周期 ================================================
  created() {
    this.flowcode = this.$route.params.flowcode?this.$route.params.flowcode:'';
    this.sellType = this.$route.params.sellType;
  },
  mounted() {
    this.flowcode = this.$route.params.flowcode?this.$route.params.flowcode:'';
    this.sellType = this.$route.params.sellType;
    this.show = false;
    setTimeout(()=>{
      this.show = true;
    },500)
  },

}
</script>
<style scoped>
.mainPart{
    /* padding: 84px 20px 20px;
    height: calc(100% - 140px); */
    padding: 84px 20px 0;
}
.pt0 >>> .searchForm{padding-top: 0 !important;}
</style>


// WEBPACK FOOTER //
// src/views/ManageFolder/ManageJsz/TransactionRecord.vue